module.exports = __webpack_public_path__ + "static/media/flecheLiBleu.a8024474.svg";